import './capabilities.component.js';
import './testimonials.component.js';